// client\src\pages\visitor\HotelSearch.jsx

import React, { useState, useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Swal from "sweetalert2";

const HotelSearch = () => {
  const [map, setMap] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [category, setCategory] = useState("hotels");
  const [results, setResults] = useState([]);

  useEffect(() => {
    // Inicializa o mapa
    const mapInstance = L.map("map").setView([20, 0], 2);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(mapInstance);
    setMap(mapInstance);
  }, []);

  const buscarLugares = async () => {
    if (!searchQuery.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Por favor",
        text: "Ingresa una ciudad o país para buscar.",
      });
      return;
    }

    try {
      // 1) Faz geocodificação pelo Nominatim
      const geocodeUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}`;
      const geocodeResponse = await fetch(geocodeUrl);
      const geocodeData = await geocodeResponse.json();

      if (geocodeData.length > 0) {
        const lat = parseFloat(geocodeData[0].lat);
        const lon = parseFloat(geocodeData[0].lon);

        // Centraliza e adiciona um marker
        if (map) {
          map.setView([lat, lon], 13);
          L.marker([lat, lon]).addTo(map).bindPopup(`<b>${searchQuery}</b>`).openPopup();
        }

        // 2) Consulta nossa rota interna que chama a API TripAdvisor
        const apiUrl = `http://localhost:4000/tripadvisor/search?searchQuery=${encodeURIComponent(
          searchQuery
        )}&category=${category}`;

        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error("Erro na requisição ao servidor.");

        const data = await response.json();
        setResults(data.results || []);
      } else {
        Swal.fire({
          icon: "warning",
          title: "No se encontró",
          text: "No se pudo encontrar la ubicación en el mapa.",
        });
      }
    } catch (error) {
      console.error("Erro ao buscar lugares:", error);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Falha ao buscar dados. Tente novamente mais tarde.",
      });
    }
  };

  return (
    <div className="container">
      <h1>Explorador de Lugares Turísticos</h1>
      
      {/* Bloco de busca unificado */}
      <div className="search-block">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Ingresa una ciudad o país"
        />
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="tourist">Puntos Turísticos</option>
          <option value="hotels">Hoteles</option>
          <option value="restaurants">Restaurantes</option>
        </select>
        <button onClick={buscarLugares}>Buscar</button>
      </div>

      {/* Mapa */}
      <div id="map" style={{ width: "100%", height: "300px", marginTop: "1rem" }}></div>

      {/* Resultados */}
      <div id="explore-results" style={{ marginTop: "1rem" }}>
        {results.length > 0 ? (
          results.map((lugar, index) => {
            const addressString = lugar?.address_obj?.address_string || "Sin dirección disponível";
            return (
              <div key={index} className="place-item">
                <h3>{lugar.name}</h3>
                <p>{addressString}</p>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressString)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ver en Google Maps
                </a>
              </div>
            );
          })
        ) : (
          <p>No se encontraron resultados.</p>
        )}
      </div>
    </div>
  );
};

export default HotelSearch;
